import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

// Numéros locaux (commencent par 0, groupes optionnels séparés par des espaces)
export const LOCAL_PHONE_PATTERN = /^0\d(?: ?\d{2,4}){1,4}$/;

// Numéros internationaux (commencent par +, suivis d'un indicatif et de groupes de chiffres)
export const INTERNATIONAL_PHONE_PATTERN = /^\+\d{1,3}(?: ?\d{1,4}){1,5}$/;

export function isValidPhone (value: string): boolean {
  return LOCAL_PHONE_PATTERN.test(value) || INTERNATIONAL_PHONE_PATTERN.test(value);
}

@Directive({
  selector: '[appPhoneValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true }]
})
export class PhoneValidatorDirective implements Validator {
  @Input('appPhoneValidator') phonePattern: string;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Si le champ est vide, ne pas appliquer la validation
    }

    // Combiner les deux patterns (local OU international)
    const phoneRegExp: RegExp = new RegExp(
      this.phonePattern || `${LOCAL_PHONE_PATTERN.source}|${INTERNATIONAL_PHONE_PATTERN.source}`
    );

    // Valider le numéro
    if (!phoneRegExp.test(control.value)) {
      return { invalidFormat: true }; // Retourner une erreur si le format est incorrect
    }

    return null; // Retourner null si le numéro de téléphone est valide
  }
}
